export const defaultState = {
  rmtReportsFilters: {
    masterUserId: '',
    startDate: '',
    endDate: ''
  }
};

const flexiRecruiterReducer = (state = defaultState, actions) => {
  switch (actions.type) {
    case 'UPDATE_FLEXI_RECRUITER_STATE': {
      state = Object.assign({}, state, actions.payload);
      break;
    }
  }

  return state;
};

export default flexiRecruiterReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/FlexiRecruiterReducer/index.js